import { styled } from '@linaria/react';

export const BannerContainer = styled.div`
	position: relative;
	width: 100%;
	min-height: 38px;
`;
